import { render, staticRenderFns } from "./addRemark.vue?vue&type=template&id=2d3a712f&scoped=true"
import script from "./addRemark.vue?vue&type=script&lang=js"
export * from "./addRemark.vue?vue&type=script&lang=js"
import style0 from "./addRemark.vue?vue&type=style&index=0&id=2d3a712f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a712f",
  null
  
)

export default component.exports